import { Helmet } from "react-helmet";
import Breadcrumb from "../components/Breadcrumb";
import classes from "./BillingPolicy.module.css";
import { Link } from "react-router-dom";

export default function BillingPolicy() {
  return (
    <>
      <Helmet>
        <title>
          Billing Policy - TechMatter UK Delivery Methods and Timelines
        </title>
        <meta
          name="description"
          content="Explore TechMatter UK's Billing Policy. Learn about delivery times, cut-off schedules, DHL shipping, handling of missing or damaged items, and fast UK-wide delivery for IT products."
        />
        <link rel="canonical" href="https://techmatter.co.uk/billing-policy" />
      </Helmet>

      <Breadcrumb currentPage="Billing Policy" />
      <div className={`container ${classes.billingPolicyContainer}`}>
        <h2 className={classes.mainHeading}>PAYMENTS</h2>
        <p className={classes.paragraph}>
          Payment via websites is accepted through popular payment methods like
          credit and debit card (Visa, Mastercaed, American Express and
          Discover) and Bank transfer. We ensure you that all our payment
          methods are secure and safely proceed. The website complies with all
          relevant standards, including those pertaining to SSL certifications.
        </p>
        <h3 className={classes.subheading}>Payment Methods:</h3>
        <ul className={classes.list}>
          <li>Credit and debit card:</li>
          <li>Visa (Including Visa Electron & Visa Debit).</li>
          <li>Mastercard.</li>
          <li>American Express.</li>
          <li>Discover.</li>
          <li>Diners Club.</li>
          <li>UnionPay.</li>
        </ul>
        <p className={classes.paragraph}>
          Card payments are mainly processed by stripes. The checkout page has
          an option of mentioning card details hosted by stripes. So in this way
          your card details never enter our website it directly goes to the
          Stripe server. For more details, you can read Stripe’s security
          documentation{" "}
          <Link
            to="https://www.visa.com/splisting/searchGrsp.do?companyNameCriteria=stripe,%20inc"
            target="_blank"
          >
            here
          </Link>{" "}
          and you can verify their validation with a visa{" "}
          <Link
            to="https://www.visa.com/splisting/searchGrsp.do?companyNameCriteria=stripe,%20inc"
            target="_blank"
          >
            here
          </Link>
        </p>
        <h3 className={classes.subheading}>Bank Transfer:</h3>
        <p className={classes.paragraph}>
          A bank transfer payment is available for both suppliers or customers,
          if they can’t pay via debit or credit cards, they can avail Bank
          transfer.
        </p>
        <p className={classes.paragraph}>
          In order to pay via bank transfer please create an account on our
          website and then contact our sales team with this link{" "}
          <Link to="https://techmatter.co.uk/contact">Contact</Link> or Call{" "}
          <Link to="tel:+442031293546">+442031293546</Link>.
        </p>{" "}
        <p className={classes.paragraph}>
          These following condition must be followed when paying through bank
          transfer:
        </p>
        <ul className={classes.list}>
          <li>
            Your confirmation receipt of payment must be received within 24
            hours after placing an order and payments must be received within 72
            hours in full.
          </li>
          <li>
            All the delivery charges and tax must be covered by the sender and
            payments in bank must be received in full and in the specified
            currency in which order was placed.
          </li>
        </ul>
        <h3 className={classes.subheading}>UK VAT</h3>
        <p className={classes.paragraph}>
          UK VAT registered customers or suppliers have to register their VAT
          number, if they want to purchase Ex VAT.
        </p>
        <p className={classes.paragraph}>
          Note that you must be registered before completing the purchase order
          because VAT is not returnable.
        </p>
        <h3 className={classes.subheading}>Payment Security & Fraud Filters</h3>
        <p className={classes.paragraph}>
          Techmatter takes care of its customer privacy and security and makes
          online purchasing experience 100% secure and safe, we ensure every
          safety measure. Our customer trust and confidence is our first
          priority. All information in our site is encrypted with SSL
          Certificates. No cardholder information is tempered by any means. We
          assure you that all the payment processes involving details of your
          payment methods or card details are not monitored, examined, used or
          modified by any third party trying to retrieve any sensitive
          information.
        </p>
        <p className={classes.paragraph}>
          In order to make online purchasing Fraud free we have strict fraud
          filters in place to prevent payment fraud. All of our payment
          procedures require 3D secure authentication. We only process payments
          through 3rd party payment processors that are PCI compliant.
          Techmatter doesn’t have any access to your payment details. We
          apologies if this is inconvenient and would appreciate your
          cooperation in resolving these issues in order to provide a smooth and
          safe online purchasing environment.
        </p>
        <h3 className={classes.subheading}>Resolving Payment Issues</h3>
        <p className={classes.paragraph}>
          If you encounter any problems with payment methods, please contact at{" "}
          <Link to="mailto:sales@techmatter.co.uk">sales@techmatter.co.uk</Link>{" "}
          Here are some potential issues:
        </p>
        <div className={classes.subItems}>
          <p className={classes.paragraph}>
            1. If you haven’t received payment confirmation but the payment has
            been deducted, please let us know so we can assist you.
          </p>
        </div>
        <p className={classes.paragraph}>
          This occurs when a customer’s connection is reset or when they refresh
          after verifying the transaction. It appears that while the payment was
          successfully processed, the system did not capture the details of your
          order. To resolve this issue, please send us an email providing the
          total payment amount, the time the payment was made, and a link to the
          product you intended to purchase. Our sales team will manually create
          the order and send you a confirmation.
        </p>
        <div className={classes.subItems}>
          <p className={classes.paragraph}>
            2. If you have been charged multiple times for the same order:
          </p>
        </div>
        <p className={classes.paragraph}>
          If your payment charge isn’t resolved within 48-72 hours, please send
          an email to{" "}
          <Link to="mailto:sales@techmatter.co.uk">sales@techmatter.co.uk</Link>{" "}
          with the proper details of the transactions. Our team will work with
          our payment partners to return the extra amount charged.
        </p>
        <div className={classes.subItems}>
          <p className={classes.paragraph}>3. Error in Payment:</p>
        </div>
        <p className={classes.paragraph}>
          If you encounter a payment error on our website, contact our sales
          team at{" "}
          <Link to="mailto:sales@techmatter.co.uk">sales@techmatter.co.uk</Link>{" "}
          and send them screenshots of any error messages. You can also try
          using other payment methods that are available.
        </p>
      </div>
    </>
  );
}
